<template>
	<div :class="['radio-group', { stacked }]">
		<div v-for="(option, index) in options" :key="option.value" class="radio-option">
			<p-radio-button :input-id="`${inputId}_${index}`" v-model="localValue" :value="option.value" />
			<label :for="`${inputId}_${index}`" class="radio-label">{{ option.label }}</label>
		</div>
	</div>
</template>

<script>
import { uniqueId } from 'lodash-es';

export default {
	name: 'RadioGroup',
	props: {
		inputId: {
			type: String,
			default: `input_${uniqueId()}`,
		},
		options: {
			type: Array,
			required: true,
		},
		modelValue: [String, Number, Array, Object, Boolean, null],
		stacked: Boolean,
	},
	computed: {
		localValue: {
			get() {
				return this.modelValue;
			},
			set(new_value) {
				this.$emit('update:modelValue', new_value);
			},
		},
	},
};
</script>
